import { render, staticRenderFns } from "./areaTab.vue?vue&type=template&id=ab8695c6&scoped=true&"
import script from "./areaTab.vue?vue&type=script&lang=js&"
export * from "./areaTab.vue?vue&type=script&lang=js&"
import style0 from "./areaTab.vue?vue&type=style&index=0&id=ab8695c6&scoped=true&lang=scss&"
import style1 from "./areaTab.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab8695c6",
  null
  
)

export default component.exports